import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Input, Button, ErrorSummary } from 'govuk-react-jsx';
import { useDispatch, useSelector } from 'react-redux';
import {
  checkOrganisationName,
  checkRegistrationNumber,
  checkBuildingAndStreet,
  checkBuildingAndStreet2,
  checkTownOrCity,
  checkCounty,
  checkPostCode,
} from '../../regex/regex';
import {
  setAccountOrganisationName,
  setAccountRegistrationNumber,
  setAccountBuildingAndStreet,
  setAccountBuildingAndStreet2,
  setAccountTownOrCity,
  setAccountCounty,
  setAccountPostCode,
  getAccountOrganisationName,
  getAccountRegistrationNumber,
  getAccountBuildingAndStreet,
  getAccountBuildingAndStreet2,
  getAccountTownOrCity,
  getAccountCounty,
  getAccountPostCode,
} from '../../features/registration/registrationJourneySlice';
import {
  getCurrentLanguage,
  getCopyProviderCY,
  getCopyProviderEN,
} from '../../features/app/appSlice';
import { updateAccountSocialHousing } from '../../firebase';
import useTitle from '../../hooks/useTitle';

const PrpIdentification = () => {
  const organisationNameRedux = useSelector(getAccountOrganisationName);
  const registrationNumberRedux = useSelector(getAccountRegistrationNumber);
  const buildingAndStreetRedux = useSelector(getAccountBuildingAndStreet);
  const buildingAndStreet2Redux = useSelector(getAccountBuildingAndStreet2);
  const townOrCityRedux = useSelector(getAccountTownOrCity);
  const countyRedux = useSelector(getAccountCounty);
  const postCodeRedux = useSelector(getAccountPostCode);

  const [errorMsgOrganisationName, setErrorMsgOrganisationName] = useState('');
  const [errorMsgRegistrationNumber, setErrorMsgRegistrationNumber] =
    useState('');
  const [errorMsgBuildingAndStreet, setErrorMsgBuildingAndStreet] =
    useState('');
  const [errorMsgBuildingAndStreet2, setErrorMsgBuildingAndStreet2] =
    useState('');
  const [errorMsgTownOrCity, setErrorMsgTownOrCity] = useState('');
  const [errorMsgCounty, setErrorMsgCounty] = useState('');
  const [errorMsgPostCode, setErrorMsgPostCode] = useState('');
  const [errorList, setErrorList] = useState([]);
  const history = useHistory();
  const dispatch = useDispatch();
  const currentLanguage = useSelector(getCurrentLanguage);
  const copyProviderCY = useSelector(getCopyProviderCY);
  const copyProviderEN = useSelector(getCopyProviderEN);
  const copyProvider =
    currentLanguage === 'en' ? copyProviderEN : copyProviderCY;

  useTitle(
    'landlordReg.PrpIdentification.s0s',
    "Provide your organsiation's details - OZEV Electric Vehicle Chargepoint Grants - GOV.UK"
  );

  const updateOrganisationName = (event) => {
    dispatch(setAccountOrganisationName(event.target.value));
  };
  const updateRegistrationNumber = (event) => {
    dispatch(setAccountRegistrationNumber(event.target.value));
  };
  const updatedBuildingAndStreet = (event) => {
    dispatch(setAccountBuildingAndStreet(event.target.value));
  };
  const updatedBuildingAndStreet2 = (event) => {
    dispatch(setAccountBuildingAndStreet2(event.target.value));
  };
  const updatedTownOrCity = (event) => {
    dispatch(setAccountTownOrCity(event.target.value));
  };
  const updatedCounty = (event) => {
    dispatch(setAccountCounty(event.target.value));
  };
  const updatedPostCode = (event) => {
    dispatch(setAccountPostCode(event.target.value));
  };

  const errorOrganisationName = copyProvider.getCopy(
    'landlordReg.PrpIdentification.s1',
    'Enter the name of your organisation'
  );

  const errorRegistrationNumber1a = copyProvider.getCopy(
    'landlordReg.PrpIdentification.s2a',
    'Enter a registration number'
  );

  const errorRegistrationNumber1b = copyProvider.getCopy(
    'landlordReg.PrpIdentification.s2b',
    'Enter a registration number between 4 and 8 characters long using letters and numbers only'
  );

  const errorBuildingAndStreet1a = copyProvider.getCopy(
    'landlordReg.PrpIdentification.s3a',
    'Enter a building and or street'
  );

  const errorBuildingAndStreet1b = copyProvider.getCopy(
    'landlordReg.PrpIdentification.s3b',
    'Enter a valid building and street'
  );

  const errorBuildingAndStreet2 = copyProvider.getCopy(
    'landlordReg.PrpIdentification.s4',
    'Enter a building and or street'
  );

  const errorTownOrCity1a = copyProvider.getCopy(
    'landlordReg.PrpIdentification.s5a',
    'Enter a town or city'
  );

  const errorTownOrCity1b = copyProvider.getCopy(
    'landlordReg.PrpIdentification.s5b',
    'Enter a valid town or city'
  );

  const errorCounty1a = copyProvider.getCopy(
    'landlordReg.PrpIdentification.s6a',
    'Enter a county'
  );

  const errorCounty1b = copyProvider.getCopy(
    'landlordReg.PrpIdentification.s6b',
    'Enter a valid county'
  );

  const errorPostCode1a = copyProvider.getCopy(
    'landlordReg.PrpIdentification.s7a',
    'Enter a postcode'
  );

  const errorPostCode1b = copyProvider.getCopy(
    'landlordReg.PrpIdentification.s7b',
    'Enter a real postcode'
  );

  const handleBtnClick = () => {
    let hasError = false;
    const errorListArr = [];
    const showErrorOrganisationName = {
      children: errorOrganisationName,
    };
    const showErrorRegistrationNumber1a = {
      children: errorRegistrationNumber1a,
    };
    const showErrorRegistrationNumber1b = {
      children: errorRegistrationNumber1b,
    };
    const showErrorBuildingAndStreet1a = {
      children: errorBuildingAndStreet1a,
    };
    const showErrorBuildingAndStreet1b = {
      children: errorBuildingAndStreet1b,
    };
    const showErrorBuildingAndStreet2 = {
      children: errorBuildingAndStreet2,
    };
    const showErrorTownOrCity1a = {
      children: errorTownOrCity1a,
    };
    const showErrorTownOrCity1b = {
      children: errorTownOrCity1b,
    };
    const showErrorCounty1a = {
      children: errorCounty1a,
    };
    const showErrorCounty1b = {
      children: errorCounty1b,
    };
    const showErrorPostCode1a = {
      children: errorPostCode1a,
    };
    const showErrorPostCode1b = {
      children: errorPostCode1b,
    };

    // set or clear the error for each field
    if (
      !checkOrganisationName.test(organisationNameRedux) ||
      organisationNameRedux === undefined
    ) {
      setErrorMsgOrganisationName(showErrorOrganisationName);
      errorListArr.push({
        ...showErrorOrganisationName,
        href: '#OrganisationName',
      });
      hasError = true;
    } else {
      setErrorMsgOrganisationName(null);
    }

    if (
      registrationNumberRedux === '' ||
      registrationNumberRedux === undefined
    ) {
      setErrorMsgRegistrationNumber(showErrorRegistrationNumber1a);
      errorListArr.push({
        ...showErrorRegistrationNumber1a,
        href: '#RegistrationNumber',
      });
      hasError = true;
    } else if (
      !checkRegistrationNumber.test(registrationNumberRedux) ||
      registrationNumberRedux === undefined
    ) {
      setErrorMsgRegistrationNumber(showErrorRegistrationNumber1b);
      errorListArr.push({
        ...showErrorRegistrationNumber1b,
        href: '#RegistrationNumber',
      });
      hasError = true;
    } else {
      setErrorMsgRegistrationNumber(null);
    }

    if (buildingAndStreetRedux === '' || buildingAndStreetRedux === undefined) {
      setErrorMsgBuildingAndStreet(showErrorBuildingAndStreet1a);
      errorListArr.push({
        ...showErrorBuildingAndStreet1a,
        href: '#BuildingAndStreet',
      });
      hasError = true;
    } else if (
      !checkBuildingAndStreet.test(buildingAndStreetRedux) ||
      buildingAndStreetRedux === undefined
    ) {
      setErrorMsgBuildingAndStreet(showErrorBuildingAndStreet1b);
      errorListArr.push({
        ...showErrorBuildingAndStreet1b,
        href: '#BuildingAndStreet',
      });
      hasError = true;
    } else {
      setErrorMsgBuildingAndStreet(null);
    }

    if (
      buildingAndStreet2Redux !== '' &&
      !checkBuildingAndStreet2.test(buildingAndStreet2Redux)
    ) {
      setErrorMsgBuildingAndStreet2(showErrorBuildingAndStreet2);
      hasError = true;
    } else {
      setErrorMsgBuildingAndStreet2(null);
    }

    if (townOrCityRedux === '' || townOrCityRedux === undefined) {
      setErrorMsgTownOrCity(showErrorTownOrCity1a);
      errorListArr.push({
        ...showErrorTownOrCity1a,
        href: '#TownOrCity',
      });
      hasError = true;
    } else if (
      !checkTownOrCity.test(townOrCityRedux) ||
      townOrCityRedux === undefined
    ) {
      setErrorMsgTownOrCity(showErrorTownOrCity1b);
      errorListArr.push({
        ...showErrorTownOrCity1b,
        href: '#TownOrCity',
      });
      hasError = true;
    } else {
      setErrorMsgTownOrCity(null);
    }

    if (countyRedux === '' || countyRedux === undefined) {
      setErrorMsgCounty(showErrorCounty1a);
      errorListArr.push({
        ...showErrorCounty1a,
        href: '#County',
      });
      hasError = true;
    } else if (!checkCounty.test(countyRedux) || countyRedux === undefined) {
      setErrorMsgCounty(showErrorCounty1b);
      errorListArr.push({
        ...showErrorCounty1b,
        href: '#County',
      });
      hasError = true;
    } else {
      setErrorMsgCounty(null);
    }

    if (postCodeRedux === '' || postCodeRedux === undefined) {
      setErrorMsgPostCode(showErrorPostCode1a);
      errorListArr.push({
        ...showErrorPostCode1a,
        href: '#PostCode',
      });
      hasError = true;
    } else if (
      !checkPostCode.test(postCodeRedux) ||
      postCodeRedux === undefined
    ) {
      setErrorMsgPostCode(showErrorPostCode1b);
      errorListArr.push({
        ...showErrorPostCode1b,
        href: '#PostCode',
      });
      hasError = true;
    } else {
      setErrorMsgPostCode(null);
    }

    // if no errors then navigate to next page
    if (!hasError) {
      updateAccountSocialHousing({
        organisationName: organisationNameRedux,
        registrationNumber: registrationNumberRedux,
        buildingAndStreet: buildingAndStreetRedux,
        buildingAndStreet2:
          buildingAndStreet2Redux === undefined ? '' : buildingAndStreet2Redux,
        townOrCity: townOrCityRedux,
        county: countyRedux,
        postCode: postCodeRedux,
      }).then(() => {
        history.push('/landlordReg/check-your-answers');
      });
    } else {
      setErrorList(errorListArr);
    }
  };

  const pageModel = (
    <>
      {errorList?.length > 0 && (
        <ErrorSummary
          errorList={errorList}
          titleChildren={copyProvider.getCopy(
            'Common.error-summery',
            'There is a problem'
          )}
        />
      )}
      <h1 className="govuk-heading-xl">
        {copyProvider.getCopy(
          'landlordReg.PrpIdentification.s8',
          "Provide your organsiation's details"
        )}
      </h1>
      <p className="govuk-body govuk-margin-bottom-2">
        {copyProvider.getCopy(
          'landlordReg.PrpIdentification.s9',
          'You will not be able to sign in to your account until we verify your details. We will send you an email when your account is ready.'
        )}
      </p>

      <div className="govuk-form-group">
        <Input
          id="OrganisationName"
          errorMessage={errorMsgOrganisationName}
          label={{
            children: copyProvider.getCopy(
              'landlordReg.PrpIdentification.s10',
              'Organisation name'
            ),
          }}
          name="OrganisationName"
          type="text"
          maxLength="250"
          value={organisationNameRedux}
          onChange={(event) => updateOrganisationName(event)}
        />
        <Input
          id="RegistrationNumber"
          errorMessage={errorMsgRegistrationNumber}
          label={{
            children: copyProvider.getCopy(
              'landlordReg.PrpIdentification.s11',
              'Registration number'
            ),
          }}
          hint={{
            children: copyProvider.getCopy(
              'landlordReg.PrpIdentification.s12',
              'Enter your social housing provider registration number or property factor ID number'
            ),
          }}
          name="RegistrationNumber"
          type="text"
          maxLength="250"
          value={registrationNumberRedux}
          onChange={(event) => updateRegistrationNumber(event)}
        />
      </div>
      <h2 className="govuk-heading-m">
        {copyProvider.getCopy('landlordReg.PrpIdentification.s13', 'Address')}
      </h2>
      <Input
        errorMessage={errorMsgBuildingAndStreet}
        id="BuildingAndStreet"
        label={{
          children: [
            <span key="0" className="govuk-label">
              {copyProvider.getCopy(
                'landlordReg.PrpIdentification.s14',
                'Building and street'
              )}
            </span>,
            <span key="1" className="govuk-visually-hidden">
              {copyProvider.getCopy(
                'landlordReg.PrpIdentification.s15',
                'line 1 of 2 '
              )}
            </span>,
          ],
        }}
        value={buildingAndStreetRedux}
        onChange={(event) => updatedBuildingAndStreet(event)}
        name="BuildingAndStreet"
        type="text"
      />

      <Input
        errorMessage={errorMsgBuildingAndStreet2}
        id="BuildingAndStreet2"
        // idPrefix="input-fields-installation-address"
        label={{
          children: (
            <span key="2" className="govuk-visually-hidden">
              {copyProvider.getCopy(
                'landlordReg.PrpIdentification.s16',
                'Building and street line 2 of 2'
              )}
            </span>
          ),
        }}
        value={buildingAndStreet2Redux}
        onChange={(event) => updatedBuildingAndStreet2(event)}
        name="BuildingAndStreet2"
        type="text"
      />

      <Input
        errorMessage={errorMsgTownOrCity}
        id="TownOrCity"
        label={{
          children: copyProvider.getCopy(
            'landlordReg.PrpIdentification.s17',
            'Town or city'
          ),
        }}
        value={townOrCityRedux}
        onChange={(event) => updatedTownOrCity(event)}
        name="TownOrCity"
        type="text"
      />

      <Input
        errorMessage={errorMsgCounty}
        formGroup={{
          className: 'govuk-!-width-two-thirds',
        }}
        id="County"
        label={{
          children: copyProvider.getCopy(
            'landlordReg.PrpIdentification.s18',
            'County'
          ),
        }}
        value={countyRedux}
        onChange={(event) => updatedCounty(event)}
        name="County"
        type="text"
      />

      <Input
        errorMessage={errorMsgPostCode}
        formGroup={{
          className: 'govuk-input--width-10',
        }}
        id="PostCode"
        label={{
          children: copyProvider.getCopy(
            'landlordReg.PrpIdentification.s19',
            'Postcode'
          ),
        }}
        value={postCodeRedux}
        onChange={(event) => updatedPostCode(event)}
        name="PostCode"
        type="text"
      />
      <Button className="govuk-button" onClick={handleBtnClick}>
        {copyProvider.getCopy('landlordReg.PrpIdentification.s20', 'Continue')}
      </Button>
    </>
  );

  return pageModel;
};

export default PrpIdentification;
